import { elementScroll } from "./react-virtual";
import throttle from "lodash.throttle";
const scrollProps = {
    element: ['scrollLeft', 'scrollTop'],
    window: ['scrollX', 'scrollY'],
};
const getHeaderHeight = (instance) => {
    return instance.options.headerHeight || 0;
};
const getFooterHeight = (instance) => {
    return instance.options.footerHeight || 0;
};
const getMaxOffset = (instance) => {
    return instance.getTotalSize() - instance.scrollElement.offsetHeight + getFooterHeight(instance);
};
export const createOffsetObserver = (mode, nonStickyHeader, disableScroll) => {
    return (instance, cb) => {
        if (!instance.scrollElement) {
            return;
        }
        const propY = scrollProps[mode][1];
        let prevY = instance.scrollElement[propY];
        const scroll = () => {
            if (nonStickyHeader) {
                const oldOffset = instance.scrollElement[propY];
                const maxOffset = getMaxOffset(instance);
                const headerHeight = getHeaderHeight(instance);
                const offset = Math.min(Math.max(0, oldOffset - headerHeight), maxOffset);
                cb(offset);
            }
            else {
                // console.log("headerHeight", (instance.options as any).headerHeight, "scrolling", "old", oldOffset, "new", offset);
                const offset = instance.scrollElement[propY];
                cb(offset);
            }
        };
        scroll();
        if (disableScroll)
            return () => void 0;
        const onScrollFn = (e) => {
            const target = e.currentTarget || e.target;
            //@ts-ignore
            const scrollY = target[propY];
            if (prevY - scrollY) {
                scroll();
            }
            prevY = scrollY;
        };
        const onScroll = throttle(onScrollFn, 0, { leading: true, trailing: true });
        instance.scrollElement.addEventListener('scroll', onScroll, { capture: false, passive: true, });
        return () => {
            instance.scrollElement.removeEventListener('scroll', onScroll);
        };
    };
};
export const createScrollToFn = (hasNonSticyHeader) => {
    if (!hasNonSticyHeader) {
        return elementScroll;
    }
    let hasRan = false;
    return (offset, options, instance) => {
        const maxOffset = getMaxOffset(instance);
        const headerHeight = getHeaderHeight(instance);
        const { behavior } = options;
        const toOffset = Math.min(Math.max(offset, 0), maxOffset) + (hasRan ? headerHeight : 0);
        instance.scrollElement?.scrollTo?.({ top: toOffset, behavior: behavior });
        hasRan = true;
    };
};
export const observeContainer = (element, onResize) => {
    if (!element)
        return;
    if (!onResize)
        return;
    const observer = new ResizeObserver((entries) => {
        const entry = entries[0];
        if (entry) {
            const { width, height } = entry.contentRect;
            onResize({ width, height });
        }
        else {
            onResize({ width: 0, height: 0 });
        }
    });
    // onResize(containerElement.getBoundingClientRect());
    observer.observe(element);
    return () => {
        observer.unobserve(element);
    };
};
export const getParentScrollElement = (ref) => {
    if (!ref)
        return [null, 0, 0];
    const element = ref.parentElement;
    if (!element)
        return [null, 0, 0];
    const { 0: first, 1: second, length, [length - 1]: last } = element.children;
    return [element, first?.offsetHeight ?? 0, last === second ? 0 : (last?.offsetHeight ?? 0)];
};
